import { render } from "./ReferendumComponent.vue?vue&type=template&id=508f4b4c&scoped=true&ts=true"
import script from "./ReferendumComponent.vue?vue&type=script&lang=ts"
export * from "./ReferendumComponent.vue?vue&type=script&lang=ts"

import "./ReferendumComponent.vue?vue&type=style&index=0&id=508f4b4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508f4b4c"]])

export default __exports__